import React from "react";
import { useNavigate } from "react-router-dom";
import { Alert, Button, App } from "antd";
import DataTable from "../../../components/DataTable";
import ActivityIndicator from "../../../components/ActivityIndicator";
import {
  useGetGradesQuery,
  useDeleteGradeMutation,
} from "../../../store/api/gradesApi";
import { GradeEntity } from "../../../services/grade/grade.types";
import PageHeader from "../../../components/PageHeader";

const Grades: React.FC = () => {
  const { notification } = App.useApp();
  const navigate = useNavigate();

  // Small full-list catalog: one list query, client-side table behavior.
  const { data, isLoading, isFetching, isError, refetch } = useGetGradesQuery();
  const [deleteGrade] = useDeleteGradeMutation();

  const grades = data ?? [];

  const handleEdit = (record: GradeEntity) => {
    navigate(`/grades/${record.id}`, { state: record.id });
  };

  const handleDelete = async (record: GradeEntity) => {
    try {
      await deleteGrade(record.id).unwrap();
      notification["success"]({
        message: "Éxito",
        description: "El grado fue eliminado exitosamente!",
        placement: "top",
        duration: 3,
      });
    } catch (error: any) {
      notification["error"]({
        message: "Eliminación Erronea",
        description: error?.data?.message || "El grado no pudo ser eliminado!",
        placement: "top",
        duration: 3,
      });
    }
  };

  return (
    <div>
      <PageHeader
        title="Grados"
        extra={
          <Button type="primary" onClick={() => navigate("/grades/new")}>
            Nuevo grado
          </Button>
        }
      />
      {isError && (
        <Alert
          type="error"
          showIcon
          style={{ marginBottom: 16 }}
          message="No se pudieron cargar los grados."
          action={
            <Button size="small" onClick={() => refetch()}>
              Reintentar
            </Button>
          }
        />
      )}
      {isLoading ? (
        <ActivityIndicator />
      ) : (
        <DataTable
          data={grades}
          columns={[
            { title: "ID", dataIndex: "id", key: "id" },
            { title: "Grado", dataIndex: "grade", key: "grade" },
            { title: "Código", dataIndex: "code", key: "code" },
          ]}
          onEdit={handleEdit}
          onDelete={handleDelete}
          loading={isFetching}
        />
      )}
    </div>
  );
};

export default Grades;
